import { Injectable } from '@angular/core';
import { navItems } from './../containers/default-layout/_nav';
import { PetService } from './pet.service';
import { PermissionINavData } from '../interfaces/nav';

@Injectable({
  providedIn: 'root',
})
export class NavService {
    public navItems = navItems;
  constructor(private petService: PetService) {}

  getNavItems(): PermissionINavData[] {
    console.log(`ngOnInit, navItems: ${JSON.stringify(navItems)}`);
    return navItems.filter((item) => {
        console.log(`getNavItems, item: ${JSON.stringify(item)}`);
        //console.log(`getNavItems, item children: ${JSON.stringify(item.children)}`);
        if(item.children)
        {
          console.log(`getNavItems, item children length: ${JSON.stringify(item.children.length)}`);
          console.log(`getNavItems, item children: ${JSON.stringify(item.children)}`);
          item.children = item.children.filter((child)=> {
            console.log(`getNavItems, child: ${JSON.stringify(child)}`);
            console.log(`getNavItems, child permission: ${JSON.stringify(child.permission)}`);
            if (!child.permission) return true; // Show items without a permission requirement
            return this.petService.hasPermission(child.permission);    
          });
        }
        if (!item.permission) return true; // Show items without a permission requirement
        return this.petService.hasPermission(item.permission);
    });
  }
}